import { Injectable } from '@angular/core';
import { BehaviorSubject, fromEvent, Observable, merge } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NetworkService {
  private online$ = new BehaviorSubject<boolean>(navigator.onLine);

  constructor() {
    // Initial status
    this.updateOnlineStatus();

    // Listen for online/offline events
    merge(fromEvent(window, 'online'), fromEvent(window, 'offline')).subscribe(() => {
      this.updateOnlineStatus();
    });
  }

  /**
   * Updates the current online status
   */
  private updateOnlineStatus(): void {
    this.online$.next(navigator.onLine);
  }

  /**
   * Returns an observable that emits the current online status
   */
  public getOnlineStatus(): Observable<boolean> {
    return this.online$.asObservable();
  }

  /**
   * Returns the current online status
   */
  public isOnline(): boolean {
    return navigator.onLine;
  }

  /**
   * Returns the current offline status
   */
  public isOffline(): boolean {
    return !this.isOnline();
  }
}
